import { useOrganizationAgentRuns } from "@api/agentRun.api";
import { useIsOrganizationChat } from "@api/chat.api";
import { useTypedFlags } from "@hooks/useTypedFlags";

/**
 * Whether the drawer offers the Agent tab. A workspace gates on the
 * `agent-runs` flag; organization chat has no workspace in the flag context,
 * so the organization list's answer is the gate: a 404 resolves to `null`
 * and hides the tab.
 */
export function useIsAgentTabShown(): boolean {
    const { agentRuns: isAgentRunsEnabled } = useTypedFlags();
    const isOrganizationChat = useIsOrganizationChat();
    const { data: organizationRuns } = useOrganizationAgentRuns({
        enabled: isOrganizationChat,
    });
    return isOrganizationChat ? organizationRuns != null : isAgentRunsEnabled;
}
